<div class="cart-notification-cont">
    @if (getTotalCartCount()) {
        {{ getTotalCartCount() }} Item{{ getTotalCartCount() > 1 ? 's' : '' }} &#x000B7; &#8377; {{ getFinalCartPrice() }}
    }
    @if (!getTotalCartCount()) {
        Your cart got empty!
    }
</div>
